const programMixin = {
  methods: {
    doesProgramHaveFeature(featuresArray, feature) {
      return featuresArray.indexOf(feature) > -1;
    }
  }
};

export default programMixin;
